export default "__VITE_ASSET__3805cbe0__"